import { render, staticRenderFns } from "./disputedReadFormGas.vue?vue&type=template&id=58efad99"
import script from "./disputedReadFormGas.vue?vue&type=script&lang=js"
export * from "./disputedReadFormGas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports